// extracted by mini-css-extract-plugin
module.exports = {"header":"MenuHeader_header__JcCBc","toolbar":"MenuHeader_toolbar__2Dp5a","title":"MenuHeader_title__3dg7q","menuIcon":"MenuHeader_menuIcon__3yEny","mark":"MenuHeader_mark__2-crL"};